/**
 * Public site origin for canonical URLs, Open Graph, and JSON-LD.
 * Set VITE_PUBLIC_SITE_URL in production (no trailing slash).
 */
export function getPublicSiteUrl(): string {
  const raw = import.meta.env.VITE_PUBLIC_SITE_URL as string | undefined;
  const trimmed = raw?.replace(/\/$/, "").trim();
  if (trimmed) return trimmed;
  if (import.meta.env.DEV && typeof window !== "undefined") {
    return window.location.origin;
  }
  return "https://lojal.app";
}
